import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect } from "react";

import { useGetApprovedProductValidatorsQuery } from "api/memberPortal/project/personnel/personnel.api";
import { ProjectPersonnel } from "api/memberPortal/project/personnel/personnel.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";
import { useLoading } from "components/UI/LoadingSpinner/UseLoading";

import { proposedValTeamColumns } from "./ProposedValTeam.columns";

const PROPOSED_VALIDATORS: ProjectPersonnel[] = [];

const ProposedValTeamTable = ({ productId }: { productId: string }) => {
  const { showLoadingSpinner, hideLoadingSpinner } = useLoading();

  const { data: proposedValTeam = PROPOSED_VALIDATORS, isLoading } =
    useGetApprovedProductValidatorsQuery(productId ?? skipToken);

  useEffect(() => {
    if (isLoading) {
      showLoadingSpinner("Loading...");
    } else {
      hideLoadingSpinner();
    }
  }, [isLoading, showLoadingSpinner, hideLoadingSpinner]);

  return (
    <DefaultDataGrid
      title="Proposed Validation Team"
      loading={isLoading}
      rows={proposedValTeam}
      columns={proposedValTeamColumns}
      getRowId={(row) => row.id}
      pageSizeOptions={[5, 10, 20, 50, 100]}
      initialState={{
        pagination: { paginationModel: { pageSize: 5, page: 0 } },
      }}
      disableColumnSelector
      disableDensitySelector
      disableColumnFilter
    />
  );
};

export default ProposedValTeamTable;
